// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen_aO2pg {
  /*--border-color : mix( #ffffff, var( --light-grey ), 50%);*/
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	flex-direction: column;
}

.header_ZiBN6 {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: 5px 10px;
}

.footer_lpoYd {
	background: var(--grey);
	height: 50px;
	padding: 10px;
	color: white;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
}

.zoom_Z0wXE {
	min-width: 120px;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-right: 20px;
}

.zoom_Z0wXE .label_S0RJ6 {
	padding-right: 10px;
}

.zoom_Z0wXE .zoomHolder_oazRO {
	flex: 1;
}

.verticalScroll_fB3MM {
	flex: 1;
	overflow-y: hidden;
	overflow-x: hidden;
	border-top: 1px solid var(--border-color);
	margin-top: 20px;
	position: relative;
}

.verticalContent_ve6KY {
	background: white;
	display: flex;
	flex-direction: row;
	align-items: stretch;
	justify-content: space-between;
	min-height: 100%;
	height: 100%;
}

.viewport_qoLPB {
	background: white;
	overflow: auto;
	NOpadding-left: 250px;
	height: 100%;
	left: 250px;
	right: 0;
	position: absolute;
}

.attributes_GiJZE {
	background: white;
	position: absolute;
	width: 250px;
	top: 0;
	left: 0;
	bottom: 15px;
	z-index: 1;
	border-right: 1px solid var(--border-color);
	overflow: hidden;
	padding-bottom: 12px;
}

.timeline_O5cFZ {
	flex: 2;
	background: var(--light-grey);
	position: relative;
	padding-bottom: 12px;
	background: white;
	min-width: 110%;
}

.timelineView_PIFr0:nth-child(0) {
	border-top: 1px solid var(--border-color);
}

.timelineView_PIFr0 {
	height: 24px;
	border-bottom: 1px solid var(--border-color);
	background: white;
	position: relative;
	overflow: hidden;
}

.timelineView_PIFr0:last-child {
	border-bottom: none;
}

.timelineGroup_o64bZ {
	box-sizing: border-box;
}

.timelineGroup_o64bZ .spacer_Z8sLK {
	height: 24px;
	background: #f5f5fd;
	border-bottom: 1px solid var(--border-color);
	border-top: 1px solid var(--border-color);
}

.attributeView_3QNiB {
	height: 24px;
	line-height: 24px;
	padding-left: 5px;
	padding-right: 10px;
	box-sizing: border-box;
}

.attributeGroup_RYZxd {
	padding-left: 10px;
}

.attributeGroup_RYZxd .title_CaOYT {
	height: 24px;
	line-height: 24px;
	margin-left: -10px;
	text-indent: 5px;
	font-weight: bold;
	background: #f5f5fd;
	border-bottom: 1px solid var(--border-color);
	border-top: 1px solid var(--border-color);
	box-sizing: border-box;
	padding-right: 10px;
}

.attributeGroup_RYZxd:first-child .title_CaOYT {
	border-top: none;
}

.cursorZone_tcYz8 {
	pointer-events: none;
	position: absolute;
	top: 0;
	bottom: 0;
	width: 24px;
	margin-left: -12px;
	background: var(--green-10);
}

.cursorTimeIndicator_9oYgn {
	width: 80px;
}

.timelineGroup_o64bZ:first-child .spacer_Z8sLK {
	border-top: none;
}

.interpolatorView_XLzYt {
	position: absolute;
	height: 24px;
	top: 0;
}

.interpolatorViewAppearance_ciqf9 {
	position: absolute;
	left: 0;
	right: 0;
	top: 10px;
	bottom: 10px;
	background: rgba(34,90,162,0.2);
	border: 1px solid #225AA2;
	pointer-events: none;
}

.timelineValue_NzdgS {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	z-index: 1;
	position: absolute;
	width: 24px;
	height: 24px;
	margin-left: -12px;
}

.timelineValueSymbol_VOIQ4 {
	width: 18px;
	height: 18px;
	border-radius: 50%;
	border: 1px solid var(--purple);
	background: var(--purple-light);
}

.boolTrue_CSo54 {
	border: 1px solid var(--green);
	background: var(--green-light);
}

.boolFalse_Q05Wx {
	border: 1px solid var(--pink);
	background: var(--pink-light);
}

.timelineValue_NzdgS.create_nqB4A {
	background: var(--purple-50);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 10px;
	color: white;
	border-radius: 50%;
	border: 3px solid white;
	pointer-events: none;
}

.timelineLabels_iyFa0 {
	position: fixed;
	margin-top: -20px;
	z-index: 10;
	height: 20px;
	width: 100%;
	overflow: hidden;
}

.timeLabel_lroT3 {
	font-size: 12px;
	position: absolute;
	height: 20px;
	line-height: 20px;
	width: 60px;
	text-align: center;
	vertical-align: middle;
	color: var(--light-grey);
}

.savingIndicator_sPKvJ {
	margin: 10px;
	font-size: 20px;
}

.errorIndicator_ypp7V {
	color: var(--pink);
}

.savingIndicator_sPKvJ {
	color: var(--yellow);
}

.savedIndicator_Kvwnh {
	color: var(--green);
}

.keyframeEditor_u4qKH,
.interpolatorEditor_0m7SL {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-content: flex-start;
}

.interpolatorEditor_0m7SL {
	nomin-height: 150px;
	min-width: 300px;
}

.keyframeEditorButtons_tzvDb,
.interpolatorEditorButtons_u8VGm {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
}

.behavior_obklK {
	max-width: 160px;
}

.popover_QBQc_.win_w2vgY {
	z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/screens/scenario/style.css"],"names":[],"mappings":"AAEA;EACE,4DAA4D;CAC7D,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;CACvB,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,OAAO;CACP,kBAAkB;CAClB,kBAAkB;CAClB,yCAAyC;CACzC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,oBAAoB;CACpB,8BAA8B;CAC9B,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,qBAAqB;CACrB,YAAY;CACZ,WAAW;CACX,QAAQ;CACR,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,MAAM;CACN,OAAO;CACP,YAAY;CACZ,UAAU;CACV,2CAA2C;CAC3C,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,OAAO;CACP,6BAA6B;CAC7B,kBAAkB;CAClB,oBAAoB;CACpB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,YAAY;CACZ,4CAA4C;CAC5C,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,4CAA4C;CAC5C,yCAAyC;AAC1C;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;CACnB,4CAA4C;CAC5C,yCAAyC;CACzC,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,WAAW;CACX,kBAAkB;CAClB,2BAA2B;AAC5B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,MAAM;AACP;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,+BAA+B;CAC/B,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,UAAU;CACV,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,+BAA+B;CAC/B,+BAA+B;AAChC;;AAEA;CACC,8BAA8B;CAC9B,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;CAC7B,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;CAC5B,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,WAAW;CACX,kBAAkB;CAClB,sBAAsB;CACtB,wBAAwB;AACzB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,aAAa;CACb,sBAAsB;CACtB,oBAAoB;CACpB,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;;CAEC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX","sourcesContent":["@import \"../../style/theme.css\";\n\n.screen {\n  /*--border-color : mix( #ffffff, var( --light-grey ), 50%);*/\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\tpadding: 5px 10px;\n}\n\n.footer {\n\tbackground: var(--grey);\n\theight: 50px;\n\tpadding: 10px;\n\tcolor: white;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.zoom {\n\tmin-width: 120px;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tmargin-right: 20px;\n}\n\n.zoom .label {\n\tpadding-right: 10px;\n}\n\n.zoom .zoomHolder {\n\tflex: 1;\n}\n\n.verticalScroll {\n\tflex: 1;\n\toverflow-y: hidden;\n\toverflow-x: hidden;\n\tborder-top: 1px solid var(--border-color);\n\tmargin-top: 20px;\n\tposition: relative;\n}\n\n.verticalContent {\n\tbackground: white;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: stretch;\n\tjustify-content: space-between;\n\tmin-height: 100%;\n\theight: 100%;\n}\n\n.viewport {\n\tbackground: white;\n\toverflow: auto;\n\tNOpadding-left: 250px;\n\theight: 100%;\n\tleft: 250px;\n\tright: 0;\n\tposition: absolute;\n}\n\n.attributes {\n\tbackground: white;\n\tposition: absolute;\n\twidth: 250px;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 15px;\n\tz-index: 1;\n\tborder-right: 1px solid var(--border-color);\n\toverflow: hidden;\n\tpadding-bottom: 12px;\n}\n\n.timeline {\n\tflex: 2;\n\tbackground: var(--light-grey);\n\tposition: relative;\n\tpadding-bottom: 12px;\n\tbackground: white;\n\tmin-width: 110%;\n}\n\n.timelineView:nth-child(0) {\n\tborder-top: 1px solid var(--border-color);\n}\n\n.timelineView {\n\theight: 24px;\n\tborder-bottom: 1px solid var(--border-color);\n\tbackground: white;\n\tposition: relative;\n\toverflow: hidden;\n}\n\n.timelineView:last-child {\n\tborder-bottom: none;\n}\n\n.timelineGroup {\n\tbox-sizing: border-box;\n}\n\n.timelineGroup .spacer {\n\theight: 24px;\n\tbackground: #f5f5fd;\n\tborder-bottom: 1px solid var(--border-color);\n\tborder-top: 1px solid var(--border-color);\n}\n\n.attributeView {\n\theight: 24px;\n\tline-height: 24px;\n\tpadding-left: 5px;\n\tpadding-right: 10px;\n\tbox-sizing: border-box;\n}\n\n.attributeGroup {\n\tpadding-left: 10px;\n}\n\n.attributeGroup .title {\n\theight: 24px;\n\tline-height: 24px;\n\tmargin-left: -10px;\n\ttext-indent: 5px;\n\tfont-weight: bold;\n\tbackground: #f5f5fd;\n\tborder-bottom: 1px solid var(--border-color);\n\tborder-top: 1px solid var(--border-color);\n\tbox-sizing: border-box;\n\tpadding-right: 10px;\n}\n\n.attributeGroup:first-child .title {\n\tborder-top: none;\n}\n\n.cursorZone {\n\tpointer-events: none;\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\twidth: 24px;\n\tmargin-left: -12px;\n\tbackground: var(--green-10);\n}\n\n.cursorTimeIndicator {\n\twidth: 80px;\n}\n\n.timelineGroup:first-child .spacer {\n\tborder-top: none;\n}\n\n.interpolatorView {\n\tposition: absolute;\n\theight: 24px;\n\ttop: 0;\n}\n\n.interpolatorViewAppearance {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 10px;\n\tbottom: 10px;\n\tbackground: rgba(34,90,162,0.2);\n\tborder: 1px solid #225AA2;\n\tpointer-events: none;\n}\n\n.timelineValue {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 1;\n\tposition: absolute;\n\twidth: 24px;\n\theight: 24px;\n\tmargin-left: -12px;\n}\n\n.timelineValueSymbol {\n\twidth: 18px;\n\theight: 18px;\n\tborder-radius: 50%;\n\tborder: 1px solid var(--purple);\n\tbackground: var(--purple-light);\n}\n\n.boolTrue {\n\tborder: 1px solid var(--green);\n\tbackground: var(--green-light);\n}\n\n.boolFalse {\n\tborder: 1px solid var(--pink);\n\tbackground: var(--pink-light);\n}\n\n.timelineValue.create {\n\tbackground: var(--purple-50);\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 10px;\n\tcolor: white;\n\tborder-radius: 50%;\n\tborder: 3px solid white;\n\tpointer-events: none;\n}\n\n.timelineLabels {\n\tposition: fixed;\n\tmargin-top: -20px;\n\tz-index: 10;\n\theight: 20px;\n\twidth: 100%;\n\toverflow: hidden;\n}\n\n.timeLabel {\n\tfont-size: 12px;\n\tposition: absolute;\n\theight: 20px;\n\tline-height: 20px;\n\twidth: 60px;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcolor: var(--light-grey);\n}\n\n.savingIndicator {\n\tmargin: 10px;\n\tfont-size: 20px;\n}\n\n.errorIndicator {\n\tcolor: var(--pink);\n}\n\n.savingIndicator {\n\tcolor: var(--yellow);\n}\n\n.savedIndicator {\n\tcolor: var(--green);\n}\n\n.keyframeEditor,\n.interpolatorEditor {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: stretch;\n\tjustify-content: flex-start;\n}\n\n.interpolatorEditor {\n\tnomin-height: 150px;\n\tmin-width: 300px;\n}\n\n.keyframeEditorButtons,\n.interpolatorEditorButtons {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.behavior {\n\tmax-width: 160px;\n}\n\n.popover.win {\n\tz-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `screen_aO2pg`,
	"header": `header_ZiBN6`,
	"footer": `footer_lpoYd`,
	"zoom": `zoom_Z0wXE`,
	"label": `label_S0RJ6`,
	"zoomHolder": `zoomHolder_oazRO`,
	"verticalScroll": `verticalScroll_fB3MM`,
	"verticalContent": `verticalContent_ve6KY`,
	"viewport": `viewport_qoLPB`,
	"attributes": `attributes_GiJZE`,
	"timeline": `timeline_O5cFZ`,
	"timelineView": `timelineView_PIFr0`,
	"timelineGroup": `timelineGroup_o64bZ`,
	"spacer": `spacer_Z8sLK`,
	"attributeView": `attributeView_3QNiB`,
	"attributeGroup": `attributeGroup_RYZxd`,
	"title": `title_CaOYT`,
	"cursorZone": `cursorZone_tcYz8`,
	"cursorTimeIndicator": `cursorTimeIndicator_9oYgn`,
	"interpolatorView": `interpolatorView_XLzYt`,
	"interpolatorViewAppearance": `interpolatorViewAppearance_ciqf9`,
	"timelineValue": `timelineValue_NzdgS`,
	"timelineValueSymbol": `timelineValueSymbol_VOIQ4`,
	"boolTrue": `boolTrue_CSo54`,
	"boolFalse": `boolFalse_Q05Wx`,
	"create": `create_nqB4A`,
	"timelineLabels": `timelineLabels_iyFa0`,
	"timeLabel": `timeLabel_lroT3`,
	"savingIndicator": `savingIndicator_sPKvJ`,
	"errorIndicator": `errorIndicator_ypp7V`,
	"savedIndicator": `savedIndicator_Kvwnh`,
	"keyframeEditor": `keyframeEditor_u4qKH`,
	"interpolatorEditor": `interpolatorEditor_0m7SL`,
	"keyframeEditorButtons": `keyframeEditorButtons_tzvDb`,
	"interpolatorEditorButtons": `interpolatorEditorButtons_u8VGm`,
	"behavior": `behavior_obklK`,
	"popover": `popover_QBQc_`,
	"win": `win_w2vgY`
};
export default ___CSS_LOADER_EXPORT___;
